import React, { useEffect } from "react";
import { assets } from "./../../Assets/assets";

const TermsAndConditions = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="relative min-h-screen bg-white dark:bg-gray-950 overflow-hidden">

      {/* Background */}
      <div
        className="absolute inset-0 opacity-[0.04] bg-repeat"
        style={{
          backgroundImage: `url(${assets.qqtlogo})`,
          backgroundSize: "180px",
        }}
      />

      <div className="relative z-10 max-w-5xl mx-auto px-6 py-12 text-gray-800 dark:text-gray-200">

        <h1 className="text-4xl font-bold mb-4 text-center">
          TERMS AND CONDITIONS
        </h1>

        {/* <p className="text-center text-sm text-gray-500 mb-10">
          Effective Date: [Insert Date] <br />
          Last Updated: [Insert Date]
        </p> */}

        {/* ================= TERMS ================= */}

        <Section title="1. Introduction">
          <p>
            Welcome to PCM Exports (“Company”, “we”, “our”, “us”), an agro-commodity trading business established in 2010.
          </p>
          <p>
            We operate an AI-enabled quotation platform under the name Quick Quotation & Trade (QQT) that facilitates real-time pricing insights and trade coordination for agro-commodities including dry fruits, spices, pulses, grains, and millets.
          </p>
          <p>
            By accessing or using our website, services, or QQT platform, you agree to be legally bound by these Terms.
          </p>
        </Section>

        <Section title="2. Eligibility">
          <ul className="list-disc pl-6 space-y-2">
            <li>You must be at least 18 years old</li>
            <li>You must be legally capable of entering into binding contracts</li>
            <li>If you are representing a business entity, you confirm authority to bind that entity</li>
          </ul>
        </Section>

        <Section title="3. Scope of Services">
          <p>PCM Exports provides:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>AI-based indicative quotation generation</li>
            <li>Trade facilitation between buyers and sellers</li>
            <li>Support in sampling, quality coordination, logistics, and payments (where applicable)</li>
          </ul>
          <p>
            Important: We act as a facilitator and service provider, not a marketplace owner or inventory holder unless explicitly stated.
          </p>
        </Section>

        <Section title="4. Nature of Quotations">
          <ul className="list-disc pl-6 space-y-2">
            <li>Quotations generated by QQT are algorithm-based and indicative only</li>
            <li>Prices are derived from market trends, user inputs, and available data</li>
            <li>Quotations are non-binding unless confirmed via formal contract or invoice</li>
          </ul>
          <p>We do not guarantee:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Accuracy of real-time market prices</li>
            <li>Availability of goods at quoted price</li>
            <li>Final transaction execution</li>
          </ul>
        </Section>

        <Section title="5. User Obligations">
          <p>You agree to:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Provide accurate, current, and complete information</li>
            <li>Maintain confidentiality of account credentials</li>
            <li>Use the platform only for lawful business purposes</li>
            <li>Not engage in fraudulent, misleading, or manipulative activities</li>
          </ul>
          <p>You must not:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Use the platform to circulate false trade information</li>
            <li>Attempt to reverse-engineer the AI system</li>
            <li>Violate any applicable export/import laws</li>
          </ul>
        </Section>

        <Section title="5.1. SMS Permissions and OTP Verification">
          <p>
            Our mobile application uses SMS-based One-Time Passwords (OTP) for secure account verification during login and transaction authentication.
          </p>

          <h3 className="text-lg font-semibold mt-4 mb-2">SMS Permissions Usage:</h3>
          <p>
            The PCM Exports mobile application requests permission to read and receive SMS messages <strong>ONLY</strong> for the following purposes:
          </p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Send One-Time Passwords (OTP) to your registered phone number for account verification</li>
            <li>Auto-detect and auto-fill OTP codes from incoming SMS messages</li>
            <li>Improve user login experience by automatically detecting OTP from SMS</li>
            <li>Enhance security during authentication and transaction processes</li>
          </ul>

          <h3 className="text-lg font-semibold mt-4 mb-2">How We Use SMS Data:</h3>
          <ul className="list-disc pl-6 space-y-2">
            <li>✓ We READ SMS messages containing OTP codes</li>
            <li>✓ We EXTRACT only the OTP code from the message</li>
            <li>✓ We AUTOMATICALLY fill the OTP input field on your device</li>
            <li>✓ We DELETE the extracted OTP from memory after verification</li>
          </ul>

          <h3 className="text-lg font-semibold mt-4 mb-2">What We Do NOT Do:</h3>
          <ul className="list-disc pl-6 space-y-2">
            <li>✗ We do NOT store or save any SMS messages</li>
            <li>✗ We do NOT access SMS content for any other purpose</li>
            <li>✗ We do NOT share SMS data with third parties</li>
            <li>✗ We do NOT use SMS data for tracking or analytics</li>
            <li>✗ We do NOT send SMS messages (we only read incoming SMS)</li>
            <li>✗ We do NOT retain SMS history on your device or our servers</li>
          </ul>

          <h3 className="text-lg font-semibold mt-4 mb-2">Android Permissions Requested:</h3>
          <ul className="list-disc pl-6 space-y-2">
            <li><strong>android.permission.READ_SMS:</strong> Used to read incoming SMS messages and extract OTP codes</li>
            <li><strong>android.permission.RECEIVE_SMS:</strong> Used to detect incoming OTP messages in real-time</li>
            <li><strong>com.google.android.gms.permission.RECEIVE_SMS:</strong> Used for Google Play Services SMS detection API</li>
          </ul>

          <h3 className="text-lg font-semibold mt-4 mb-2">User Control Over SMS Permissions:</h3>
          <p>
            SMS permissions are <strong>OPTIONAL</strong>. Users can:
          </p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Deny SMS permissions when prompted by the application</li>
            <li>Revoke permissions anytime in device Settings</li>
            <li>Manually enter OTP if auto-fill is disabled or not available</li>
            <li>Continue using the application with manual OTP entry (no auto-fill functionality)</li>
          </ul>

          <h3 className="text-lg font-semibold mt-4 mb-2">How to Revoke SMS Permissions (Android):</h3>
          <ol className="list-decimal pl-6 space-y-2">
            <li>Open your device <strong>Settings</strong></li>
            <li>Navigate to <strong>Apps & Notifications</strong> or <strong>Application Manager</strong></li>
            <li>Find and tap on <strong>PCM Exports</strong></li>
            <li>Go to <strong>Permissions</strong></li>
            <li>Find <strong>SMS</strong> permission</li>
            <li>Tap to <strong>Deny</strong> or <strong>Revoke</strong> the permission</li>
          </ol>

          <h3 className="text-lg font-semibold mt-4 mb-2">Data Security:</h3>
          <ul className="list-disc pl-6 space-y-2">
            <li>All SMS data is processed locally on your device only</li>
            <li>No SMS content or OTP codes are transmitted to external servers</li>
            <li>OTP codes are automatically deleted from device memory after verification</li>
            <li>All communication with our servers is encrypted</li>
            <li>We comply with data protection and privacy regulations</li>
          </ul>

          <h3 className="text-lg font-semibold mt-4 mb-2">Data Retention:</h3>
          <ul className="list-disc pl-6 space-y-2">
            <li><strong>SMS Messages:</strong> NOT stored permanently</li>
            <li><strong>OTP Codes:</strong> Deleted immediately after verification</li>
            <li><strong>Phone Number:</strong> Stored in your account until you delete your profile</li>
            <li><strong>Device Information:</strong> Deleted after your session ends</li>
          </ul>

          <h3 className="text-lg font-semibold mt-4 mb-2">iOS Users:</h3>
          <p>
            Note: iOS does not provide native SMS reading capabilities. iOS users must manually enter OTP codes sent to their registered phone number.
          </p>

          <h3 className="text-lg font-semibold mt-4 mb-2">User Responsibilities:</h3>
          <ul className="list-disc pl-6 space-y-2">
            <li>Ensure your phone number is current and secure</li>
            <li>Do not share OTP codes with anyone, including PCM Exports staff</li>
            <li>Report suspicious or unauthorized access attempts immediately</li>
            <li>Keep your device secure and updated</li>
            <li>Enable SMS permissions only if you consent to this usage</li>
          </ul>

          <h3 className="text-lg font-semibold mt-4 mb-2">Changes to This Policy:</h3>
          <p>
            We may update this SMS permissions policy at any time. We will notify users of major changes through the application or via email. Continued use of the application after updates means you accept the revised terms.
          </p>

          <h3 className="text-lg font-semibold mt-4 mb-2">Contact Us:</h3>
          <p>
            If you have questions about our SMS permission usage or data handling:
          </p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Email: <strong>[pcmexportsbbsr@gmail.com]</strong></li>
            <li>Website: <strong>[www.pcmexports.com]</strong></li>
            <li>Address: <strong>[Block-A, Bharati Tower, Forestpark, Ekamra Marg, Bhimpur, Bhubaneswar, Khordha, Odisha(India) - 751009]</strong></li>
          </ul>

          <p className="mt-4 font-semibold">
            By using the PCM Exports mobile application, you acknowledge that you have read this section and consent to the SMS permission usage as described above.
          </p>
        </Section>

        <Section title="6. Trade and Transactions">
          <ul className="list-disc pl-6 space-y-2">
            <li>Transactions may occur directly between buyer and seller or via PCM Exports (if contracted)</li>
            <li>All key terms (price, quantity, quality, delivery, payment) must be mutually agreed</li>
          </ul>
          <p>PCM Exports:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Does not guarantee performance of either party</li>
            <li>Is not responsible for breach of contract between buyer and seller</li>
            <li>May assist in coordination but does not assume liability</li>
          </ul>
        </Section>

        <Section title="7. Payments">
          <ul className="list-disc pl-6 space-y-2">
            <li>Payments may be processed through third-party gateways (e.g., Razorpay)</li>
            <li>Users agree to comply with payment provider terms</li>
            <li>PCM Exports is not liable for payment delays due to banking systems or third-party processors</li>
          </ul>
        </Section>

        <Section title="8. Logistics and Delivery">
          <ul className="list-disc pl-6 space-y-2">
            <li>Logistics services, if arranged, are handled by third-party providers</li>
            <li>Delivery timelines are indicative and subject to external factors (weather, customs, transport issues)</li>
            <li>Risk transfer terms depend on agreed Incoterms (if applicable)</li>
          </ul>
        </Section>

        <Section title="9. Quality and Sampling">
          <ul className="list-disc pl-6 space-y-2">
            <li>Sampling and quality checks are based on mutually agreed standards</li>
            <li>PCM Exports may facilitate quality checks but does not provide guarantees unless explicitly contracted</li>
          </ul>
        </Section>

        <Section title="10. Intellectual Property">
          <p>All rights related to:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>QQT platform</li>
            <li>AI algorithms</li>
            <li>Website content, branding, and design</li>
          </ul>
          <p>
            are owned exclusively by PCM Exports. Unauthorized use, copying, or distribution is strictly prohibited.
          </p>
        </Section>

        <Section title="11. Data Usage">
          <p>
            Use of the platform is also governed by our Privacy Policy. By using the platform, you consent to data collection and usage as described there.
          </p>
        </Section>

        <Section title="12. Limitation of Liability">
          <p>To the maximum extent permitted by law, PCM Exports shall not be liable for:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Loss of profits, business, or opportunity</li>
            <li>Trade disputes between parties</li>
            <li>Incorrect quotations due to system or data limitations</li>
            <li>Delays, damages, or losses in logistics</li>
            <li>Force majeure events</li>
          </ul>
        </Section>

        <Section title="13. Indemnification">
          <p>You agree to indemnify and hold PCM Exports harmless against:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Claims arising from your misuse of the platform</li>
            <li>Legal violations</li>
            <li>Contractual disputes with third parties</li>
          </ul>
        </Section>

        <Section title="14. Termination">
          <ul className="list-disc pl-6 space-y-2">
            <li>We reserve the right to suspend or terminate access without prior notice</li>
            <li>Remove users engaging in suspicious or unlawful activity</li>
          </ul>
        </Section>

        <Section title="15. Governing Law and Jurisdiction">
          <p>
            These Terms shall be governed by the laws of India. Jurisdiction: Bhubaneswar, Odisha
          </p>
        </Section>

        <Section title="16. Amendments">
          <p>
            We may update these Terms at any time. Continued use of the platform constitutes acceptance.
          </p>
        </Section>
      </div>
    </div>
  );
};

const Section = ({ title, children }) => (
  <section className="mb-8">
    <h2 className="text-2xl font-semibold mb-3">{title}</h2>
    <div className="space-y-2">{children}</div>
  </section>
);

export default TermsAndConditions;